import Logo from '../../assets/logo.png';
import './inicio.css';
import { useEffect, useState, useRef } from 'react';
import Modal from '../../components/Modal';
import axios from 'axios';
import io from 'socket.io-client';



const httpRequest = 'https://servidor1nodered.vexpressarmarios.com/kiosk';
const httpApiKey = '2bec1111-4177-4064-9234-7c3b6a0838be';


export default function Inicio() {


    const [carregando, setCarregando] = useState(true);
    const [tokenValido, setTokenValido] = useState(false);


    const [token, setToken] = useState('');
    const [infoToken, setInfoToken] = useState('');
    const [showPostModal, setShowPostModal] = useState(false);
    const [infoModal, setInfoModal] = useState('');

    const socket = useRef(null);
    const cameraTela = useRef(null);
    const camera2 = useRef(null);
    const camera3 = useRef(null);

    const [cameraTelaState, setCameraTelaState] = useState(false);
    const [cameraTelaTitulo, setCameraTelaTitulo] = useState('');
    const [camera2State, setCamera2State] = useState(false);
    const [camera2Titulo, setCamera2Titulo] = useState('');
    const [camera3State, setCamera3State] = useState(false);
    const [camera3Titulo, setCamera3Titulo] = useState('');

    const renderCount = useRef(0);




    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tokenUrl = urlParams.get('token');
        setToken(tokenUrl);

        axios.post(`${httpRequest}`, {
            authorization: httpApiKey,
            modo: "verificarToken",
            token: tokenUrl
        })
            .then((response) => {
                console.log(response.data);
                if (response.data !== 'invalido') {
                    console.log("Token válido.");
                    console.log(response.data);
                    setTokenValido(true);
                    setInfoToken(response.data);
                    setCarregando(false);
                }
                else {
                    console.log("Token inválido.");
                    setTokenValido(false);
                    setCarregando(false);
                }
            })
            .catch((error) => {
                console.error('Erro na requisição:', error);
            });
    }, []);


    useEffect(() => {
        const intervalId = setInterval(() => {
            if (infoToken && infoToken.dtLimite) {
                const dtLimite = new Date(infoToken.dtLimite).getTime();
                const now = new Date().getTime();
                if (dtLimite > now) {
                    if (socket.current && socket.current.connected) {
                        socket.current.emit("ligarCamera", "true");
                    }
                    setTokenValido(true);
                } else {
                    setTokenValido(false);
                }
            }
        }, 5000);

        return () => clearInterval(intervalId);
    }, [infoToken]);



    useEffect(() => {
        if (tokenValido && infoToken) {
            socket.current = io(infoToken.urlKiosk);

            socket.current.on('connect', () => {
                console.log('Socket conectado');
                socket.current.emit("ligarCamera", "true");
            });

            socket.current.on('cameraTela', (data) => {
                setCameraTelaState(true);
                if (cameraTela.current) {
                    cameraTela.current.src = `data:image/jpeg;base64,${data.img}`;
                    setCameraTelaTitulo(data.titulo);
                }
            });

            socket.current.on('camera_2', (data) => {
                setCamera2State(true);
                if (camera2.current) {
                    camera2.current.src = `data:image/jpeg;base64,${data.img}`;
                    setCamera2Titulo(data.titulo);
                }
            });

            socket.current.on('camera_3', (data) => {
                setCamera3State(true);
                if (camera3.current) {
                    camera3.current.src = `data:image/jpeg;base64,${data.img}`;
                    setCamera3Titulo(data.titulo);
                }
            });

            return () => {
                socket.current.disconnect();
            };
        }
    }, [tokenValido, infoToken]);




    function handleLiberarAcesso() {

        
        axios.post(`${infoToken.urlKiosk}/nodered/api`, {
            authorization: httpApiKey,
            modo: "liberarAcesso",
            idKiosk: infoToken.idKiosk,
            tipo: infoToken.tipo,
            token: infoToken.token,
            urlKiosk: infoToken.urlKiosk,
            idCondominio: infoToken.idCondominio,
            apt: infoToken.apt,
        })
            .then((response) => {
                if (response) {
                    setShowPostModal(true);
                    setInfoModal('ACESSO LIBERADO');


                    axios.post(`${httpRequest}`, {
                        authorization: httpApiKey,
                        modo: "liberarAcesso",
                        idKiosk: infoToken.idKiosk,
                        tipo: infoToken.tipo,
                        token: infoToken.token,
                        urlKiosk: infoToken.urlKiosk,
                        idCondominio: infoToken.idCondominio,
                        apt: infoToken.apt,
                    })
                        .then((response) => {
                        })
                        .catch((error) => {
                            console.error('Erro na requisição:', error);
                        });
                }
                else {
                    setShowPostModal(true);
                    setInfoModal('ERRO AO LIBERAR ACESSO');
                }
            })
            .catch((error) => {
                console.error('Erro na requisição:', error);
            });

    }




    return (
        <div className="container">


            {tokenValido ? (
                <>
                    <img src={Logo} alt="Logo" className="logo" />


                    {cameraTelaState && (
                        <div className='container-camera'>
                            <h1>{cameraTelaTitulo}</h1>
                            <img className='video-caixa' ref={cameraTela} src={''} alt="Foto da Câmera" />
                        </div>
                    )}


                    {camera2State && (
                        <div className='container-camera'>
                            <h1>{camera2Titulo}</h1>
                            <img className='video-caixa' ref={camera2} src={''} alt="Foto da Câmera" />
                        </div>
                    )}


                    {camera3State && (
                        <div className='container-camera'>
                            <h1>{camera3Titulo}</h1>
                            <img className='video-caixa' ref={camera3} src={''} alt="Foto da Câmera" />
                        </div>
                    )}


                    {!showPostModal && (
                        <button onClick={handleLiberarAcesso}>LIBERAR O ACESSO</button>
                    )}
                </>
            ) : (
                <>
                    <img src={Logo} alt="Logo" className="logo" />
                    {!carregando && <h2>TOKEN INVÁLIDO</h2>}
                </>
            )}

            {carregando && <h2>CARREGANDO</h2>}


            {showPostModal && (
                <Modal
                    conteudo={infoModal}
                    close={() => setShowPostModal(false)}
                />
            )}
        </div>
    );
}
